<template lang='pug'>
  .tinymce
    editor(id='tinymce' v-model='tinymceHtml.html' :init='init')
    el-button(type="primary" size="small" @click="onSubmit" :disabled="status > 0") 提交
</template>

<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/icons/default/icons'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
export default {
  name: 'tinymce',
  components: { Editor },
  props: {
    tinymceHtml: Object,
    status: Number
  },
  data () {
    return {
      init: {
        language_url: '/js/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'js/skins/ui/oxide',
        invalid_styles: {
          td: 'width',
          th: 'width'
        },
        height: 500,
        plugins: 'lists image table wordcount',
        // toolbar:
        //   'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | undo redo | link unlink image | removeformat',
        toolbar:
          'alignleft aligncenter alignright alignjustify | subscript superscript ',
        branding: false,
        menubar: 'edit table',
        table_row_advtab: false,
        table_cell_advtab: false,
        table_advtab: false,
        // table_resize_bars: false,
        table_default_styles: {
          width: '100%',
          'border-color': '#EBEBEB',
          color: '#333333',
          'font-size': '1rem'
        },
        content_style: 'th {color: #FFFFFF;background-color: #E8392A;font-size:1.2rem;font-weight:bold}'
      }
    }
  },
  mounted () {
    tinymce.init({ })
  },
  watch: {
    tinymceHtml: {
      handler (val, oldval) {
        const regW = /width\s*=(['\\"\s]?)[^'\\"]*?\1/gi // 匹配  width=
        const regH = /height\s*=(['\\"\s]?)[^'\\"]*?\1/gi
        const regH2 = /height\s*:(['\\"\s]?)[^'\\"]*?\1/gi
        const regc = new RegExp('class="(.*?)"', 'g')
        const regp = /(<\/?span.*?>)|(<\/?p.*?>)/gi
        const regtr = /<tr[^>]*>/gi
        const regtab = /<table[^>]*>/gi
        var reg1 = /<colgroup[^>]*>.*<\/colgroup>/gi
        // let regtd = /<td[^>]*>/gi
        const tableStr = '<table style="width: 100%; border-color: #ebebeb; color: #333333; font-size: 1rem;" border="1">'
        this.tinymceHtml.html = val.html.replace(regc, '').replace(regp, '').replace(regtr, '<tr>').replace(regtab, tableStr).replace(reg1, '').replace(regW, '').replace(regH, '').replace(regH2, '')
      },
      deep: true
    }
  },
  methods: {
    onSubmit () {
      // console.log('HTML：' + this.tinymceHtml.html)
      var text = tinymce.activeEditor.getContent({ format: 'text' })
      text = text.replace(/\s+/g, '')

      const content = { html: this.tinymceHtml.html, pureText: text }
      this.$emit('addTable', content)
    }
  }
}
</script>

<style src="tinymce/skins/content/default/content.css" rel="stylesheet" type="text/css"  scoped>
</style>
